import { PackageStatus } from '@qdrant/qdrant-cloud-public-api/booking/v1';
import { type ClusterNodeResourcesSummaryValid } from '@qdrant/qdrant-cloud-public-api/cluster/v1';
import { MILLICENTS_TO_DOLLAR_OR_EURO_FACTOR } from '@/components/Clusters/constants';
import { type DeepOmitProtobufInternals } from '@/connect-query';

export type ClusterResourceType = keyof DeepOmitProtobufInternals<ClusterNodeResourcesSummaryValid>;

/**
 * BookingStatus
 * @description
 * PLANNED - 1: The booking is planned, but not yet active
 * ACTIVE - 2: The booking is active
 * DEACTIVATED - 3: The booking is deactivated
 */
export const BOOKING_STATUS: Record<string, PackageStatus> = {
  PLANNED: PackageStatus.UNSPECIFIED,
  ACTIVE: PackageStatus.ACTIVE,
  DEACTIVATED: PackageStatus.DEACTIVATED,
};

export function convertToReadableUnitPrice(unitPrice?: number): string {
  return `$${unitPrice ? (unitPrice / MILLICENTS_TO_DOLLAR_OR_EURO_FACTOR).toFixed(2) : 0}`;
}
